const prefix = 'task/'

const type = {
    GET_LIST_TASK: prefix + 'get_list_task',
    GET_LIST_TASK_DONE: prefix + 'get_list_task_done',
    UPDATE_TASK_STATUS: prefix + 'update_task_status',
    CREATE_NEW_TASK: prefix + 'create_new_task',
    VISIBLE_EDIT_MODAL: prefix + 'visible_edit_modal',
    GET_CURRENT_TASK: prefix + 'get_current_task',
    GET_CURRENT_TASK_DONE: prefix + 'get_current_task_done',
}
const loadType = {
    GET_ALL: -1,
    GET_NOT_DELETED: 0,
    GET_DELETED: 1,
}
const action = {
    getListTask: (page_number, page_size, deleted) => {
        return {
            type: type.GET_LIST_TASK,
            payload: {
                page_number,
                page_size,
                deleted,
            },
        }
    },
    getListTaskDone: data => {
        return {
            type: type.GET_LIST_TASK_DONE,
            payload: {
                data,
            },
        }
    },
    updateTaskStatus: (task_id, status) => {
        return {
            type: type.UPDATE_TASK_STATUS,
            payload: {
                task_id,
                status,
            },
        }
    },
    createNewTask: body => {
        return {
            type: type.CREATE_NEW_TASK,
            payload: {
                body,
            },
        }
    },
    visibleEditModal: visible => {
        return {
            type: type.VISIBLE_EDIT_MODAL,
            payload: {
                visible,
            },
        }
    },
    getCurrentTask: id => {
        return {
            type: type.GET_CURRENT_TASK,
            payload: {
                id,
            },
        }
    },
    getCurrentTaskDone: data => {
        return {
            type: type.GET_CURRENT_TASK_DONE,
            payload: {
                data,
            },
        }
    },
}

export default {
    type,
    action,
    loadType,
}
